import type { ReactNode } from 'react';

export const symbol_format_quote_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M835-79.61Q826-71 813.5-71T792-80L434-437 329-255q-4 8-11.5 11.5t-15.99 3.5q-17.76 0-26.63-15.5Q266-271 275-287l67-115q-5 1-11 1.5t-11 .5q-66 0-113-47t-47-113q0-32 11.42-58.82Q182.84-645.65 203-668L89-782q-9-8.5-9-21.25T88.61-825q9.39-9 21.86-9 12.46 0 21.53 9l703 703q9 9 9 21t-9 21.39ZM320-480q15 0 28-5t24-14L259-612q-9 11-14 24t-5 28q0 33.33 23.33 56.67Q286.67-480 320-480Zm416.5-23.26q23.5-23.27 23.5-56.5 0-33.24-23.26-56.74-23.27-23.5-56.5-23.5-33.24 0-56.74 23.26-23.5 23.27-23.5 56.5 0 33.24 23.26 56.74 23.27 23.5 56.5 23.5 33.24 0 56.74-23.26ZM325-546Zm355-14Zm17 215L538-504q-12.11-12.06-17.55-26.53Q515-545 515-562q0-26 11.5-52t30.5-49q22-26 53.5-41.5T680-720q66 0 113 47t47 113q0 21-5.5 41.5T818-480l-74 129q-8 13-22 15t-25-9Z"
		/>
	</svg>
);
